import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { directDocAttachment } from 'src/app/models/IPharmacyDirectory';
export interface DialogData {
  url: any;
  orderObj: directDocAttachment;
}
@Component({
  selector: 'app-direct-message-preview-file',
  templateUrl: './direct-message-preview-file.component.html',
  styleUrls: ['./direct-message-preview-file.component.css']
})
export class DirectMessagePreviewFileComponent implements OnInit {
  docUrl: any;
  constructor(public dialogRef: MatDialogRef<DirectMessagePreviewFileComponent>,
    @Inject(MAT_DIALOG_DATA) public dmObj: DialogData,private sanitizer: DomSanitizer) { 
      this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:'+dmObj.orderObj.documenttype+';base64,' + dmObj.orderObj.documentdata);
    }

  ngOnInit() {
  }
  onNoClick(){
    this.dialogRef.close();
  }
}
